import { useContext } from 'react'

import { ToastContext } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import useTryOnWidgetConfiguration from './hooks/useTryOnWidgetConfiguration/useTryOnWidgetConfiguration'
import TryOnWidgetConfiguration from './TryOnWidgetConfiguration/TryOnWidgetConfiguration'
import TryOnWidgetConfigurationPageSkeleton from './TryOnWidgetConfigurationPageSkeleton/TryOnWidgetConfigurationPageSkeleton'
import * as Styles from './styles'

const TryOnWidgetConfigurationPage = () => {
  const { info } = useContext(AppContext)
  const { hasPermission } = useUserPermissions()
  const { setToastInfo } = useContext(ToastContext)

  const {
    backgroundColor,
    setBackgroundColor,
    textColor,
    setTextColor,
    buttonColor,
    setButtonColor,
    buttonHoverColor,
    setButtonHoverColor,
    fetchingTryOnWidgetPreferences,
    hasChanges,
    scriptInfo,
    onSave,
    editing,
    revertChanges,
    productTaxonomyDisplay,
    setProductTaxonomyDisplay,
    productTaxonomyType,
    setProductTaxonomyType,
    productTaxonomyIds,
    setProductTaxonomyIds,
    productCategories,
    productCollections,
    previewProduct,
    tryonMode,
  } = useTryOnWidgetConfiguration({
    storeId: info.selectedStore.id,
    setToastInfo,
    storeProvider: info.selectedStore.provider,
  })

  if (fetchingTryOnWidgetPreferences) {
    return <TryOnWidgetConfigurationPageSkeleton />
  }

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editExtra)} />}
      <TryOnWidgetConfiguration
        backgroundColor={backgroundColor}
        setBackgroundColor={setBackgroundColor}
        textColor={textColor}
        setTextColor={setTextColor}
        buttonColor={buttonColor}
        setButtonColor={setButtonColor}
        buttonHoverColor={buttonHoverColor}
        setButtonHoverColor={setButtonHoverColor}
        productTaxonomyDisplay={productTaxonomyDisplay}
        setProductTaxonomyDisplay={setProductTaxonomyDisplay}
        productTaxonomyType={productTaxonomyType}
        setProductTaxonomyType={setProductTaxonomyType}
        productTaxonomyIds={productTaxonomyIds}
        setProductTaxonomyIds={setProductTaxonomyIds}
        productCategories={productCategories}
        productCollections={productCollections}
        previewProduct={previewProduct}
        scriptInfo={scriptInfo}
        store={info.selectedStore}
        tryonMode={tryonMode}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editExtra) && hasChanges}
        onSave={onSave}
        onRevertChanges={revertChanges}
        loading={editing}
        disabled={editing}
      />
    </Styles.Container>
  )
}

export default TryOnWidgetConfigurationPage
